import { DateTime } from 'luxon';
import React from 'react';
import { BrowserView } from 'react-device-detect';

import Imagem from 'Component/Imagem';
import Usuario from 'Interface/Usuarios';

interface Props {
  dados: Usuario;
}

const AniversarioLista = ({ dados }: Props): React.ReactElement => {
  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3">
      <Imagem
        src={dados.imagem}
        alt={dados.nome}
        className="rounded-circle object-fit-cover"
        width="80"
        height="80"
      />
      <div className="ms-4 fs-4" style={{ flex: 2 }}>
        {dados.nome}
        <small className="d-block fs-6 text-muted">{dados.email}</small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end" style={{ flex: 1 }}>
        <div className="ms-5 fs-5 text-end" style={{ flex: 1 }}>
          {Math.abs(dados.nascimento.data().diff(DateTime.now(), 'years').toObject().years || 0).toFixed(0)}
          <small className="d-block fs-6 text-muted">Idade</small>
        </div>
        <div className="ms-5 fs-5 text-end" style={{ flex: 1 }}>
          {dados.nascimento.data().toFormat('dd/MM')}
          <small className="d-block fs-6 text-muted">Aniversário</small>
        </div>
      </BrowserView>
    </div>
  );
};

export default AniversarioLista;
